import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'

export default {
  name: 'AccessQrModal',
  extends: BaseModal,
  data: function () {
    return {
      qrCode: null,
      blocker: false,
    }
  },
  mounted() {
    this.fetchQr()
  },
  methods: {
    fetchQr() {
      this.blocker = true
      axios({
        method: 'get',
        url: `boxes/${this.data.boxId}/access_qr?data_url=1`,
      })
        .then(response => {
          this.qrCode = response.data
          this.blocker = false
          console.log('createDeliveryRequest response', response.data)
        })
        .catch(error => {
          this.blocker = false
          console.error('createDeliveryRequest error', error.response)
        })
    },

    // copyQR() {
    //   // permission needed
    //   // https://developers.google.com/web/updates/2018/03/clipboardapi
    //   // https://web.dev/image-support-for-async-clipboard/
    //   let imageBlob = this.dataURItoBlob(this.qrCode);
    //   try {
    //     navigator.clipboard.write([
    //       new ClipboardItem({
    //         'image/png': imageBlob
    //       })
    //     ]);
    //     toastStore.commit('success', { message: 'QR Copied succesfully!' });
    //   } catch (error) {
    //     toastStore.commit('success', { message: 'Error during QR copy!' });
    //   }
    // },

    copyQR() {
      const el = document.createElement('textarea')
      el.value = 'test url'
      document.body.appendChild(el)

      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        var editable = el.contentEditable
        var readOnly = el.readOnly

        el.contentEditable = true
        el.readOnly = true

        var range = document.createRange()
        range.selectNodeContents(el)

        var selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        el.setSelectionRange(0, 999999)

        el.contentEditable = editable
        el.readOnly = readOnly
      } else {
        el.select()
      }

      document.execCommand('copy')
      document.body.removeChild(el)
      toastStore.commit('success', { message: this.$t('general.qrCodeLinkCopied') })
    },

    downloadQR() {
      this.$refs.link.click()
      toastStore.commit('success', { message: this.$t('general.qrCodeDownloaded') })
    },

    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      var blob = new Blob([ab], { type: mimeString })
      return blob
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
